export const activitiesLength = state => state.activities.length

export const findActivity = (state, id) => state.activities.find(s => s.id === id)

export const sortedActivities = state => state.activities.sort((a, b) => a.date < b.date)

export const isLoaded = state => state.isLoaded

export default {
  findActivity,
  isLoaded,
  activitiesLength,
  sortedActivities
}
